import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-claim-submission-gl",
  templateUrl: "./claim-submission-gl.component.html",
  styleUrls: ["./claim-submission-gl.component.scss"],
})
export class ClaimSubmissionGlComponent {
  resetOnlineSubmissionTab: Boolean = false;
  resetAdditionalDocSubmissionTab: Boolean = false;
  protected selectedTab: number = 0;

  resetOnlineClaimSubmissionTab(data) {
    this.selectedTab = data;
    sessionStorage.removeItem("requestToken");

    if (data == 1) {
      this.resetOnlineSubmissionTab = true;
    } else {
      this.resetAdditionalDocSubmissionTab = true;
    }
  }

  resetOnlineSubmissionTabValue() {
    this.resetOnlineSubmissionTab = false;
  }

  resetAdditionalDocSubmissionTabValue() {
    this.resetAdditionalDocSubmissionTab = false;
  }
}
